module.exports = __webpack_public_path__ + "static/media/africa-middle-east.e1053420.png";